import script from "./ArchivedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivedProducts.vue?vue&type=script&setup=true&lang=js"

import "./ArchivedProducts.vue?vue&type=style&index=0&id=3ddd554c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddd554c"]])

export default __exports__